import React from "react";

interface Props {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  [key: string]: any;
}

export function TableInput({ value, onChange, ...rest }: Props) {
  return (
    <input
      value={value}
      onChange={onChange}
      {...rest}
      className="h-[54px] w-full rounded-[4px] border-[1px] border-gray-1 bg-[#fafafa] px-[24px] py-[16px] text-M3 outline-none placeholder:text-[#c6c6c6] read-only:text-gray-3 focus:border-gray-5 focus:ring-0 read-only:focus:border-gray-1"
    />
  );
}
